import { loaderAction, setInvoiceSumFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { GetInvoicesThunk } from "./GetInvoicesThunk";
import { INVOICE_SUM_FORM_INITIAL } from "../initialStateConstant";

export const RemoveInvoiceThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('invoice_id', args.invoice_id);

        const response = await api({ data: formData, link: 'remove_invoice' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму редактирования суммы счёта
            dispatch(setInvoiceSumFormAction(INVOICE_SUM_FORM_INITIAL));

            // Запрашиваем обновлённые данные
            dispatch(GetInvoicesThunk());

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};